// DS2.3
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { getIconSizeForButtonSize } from '../helpers';
import s from './TextButton.scss';
const TextButton = (_param)=>{
    var { size , noHorizontalPaddings =true , variant , priority ='primary' , className , children , icon: IconComponent , iconProps , postfixIcon: PostFixIconComponent , iconClassName , loading  } = _param, props = _object_without_properties(_param, [
        "size",
        "noHorizontalPaddings",
        "variant",
        "priority",
        "className",
        "children",
        "icon",
        "iconProps",
        "postfixIcon",
        "iconClassName",
        "loading"
    ]);
    const iconSize = getIconSizeForButtonSize(size);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
        className: classnames(className, s['root'], s[`variant-${variant}`], s[`priority-${priority}`], s[`size-${size}`], noHorizontalPaddings && s['no-horizontal-paddings'], props.disabled && s['disabled'], loading && s['loading'])
    }, props), IconComponent && /*#__PURE__*/ React.createElement(IconComponent, _extends({
        className: classnames(s['icon'], iconClassName),
        size: iconSize,
        disableDefaultColors: true
    }, iconProps)), /*#__PURE__*/ React.createElement("span", {
        className: s['content']
    }, children), PostFixIconComponent && /*#__PURE__*/ React.createElement(PostFixIconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }));
};
TextButton.displayName = 'TextButton';
export default TextButton;
